module.exports = __webpack_public_path__ + "img/productRobot_20.ffa03917.png";